export default __webpack_public_path__ + "static/media/bq-sa.dcd89d69.svg";